import {combineReducers, createStore} from 'redux';
import authReducer from './auth.reducer';
import proyectsReducer from './proyects.reducer';
import pcgReducer from './pc_general.reducer';
import cashFlow from './cash_flow.reducer';
import logisticIndicators from './logistic-indicators.reducer';

const rootReducer = combineReducers({
    auth: authReducer,
	proyects: proyectsReducer,
	pcg: pcgReducer,
	cashFlow,
	logisticIndicators,
})

export const store = createStore(rootReducer);


export default rootReducer;